import '@hotwired/turbo-rails'
import '~/turbo_confirm'
import '~/controllers'

// Page-wide date picker (I-DP-01): <html> survives Turbo visits and morphs, so one controller covers every date input.
document.documentElement.setAttribute('data-controller', `${document.documentElement.dataset['controller'] ?? ''} datepicker`.trim())
